var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
import classNames from "classnames";
import React from "react";
import { MenuItemLink } from "../item/Link";
import { menuListTitleCls } from "./List.less";
function MenuListTitle(props) {
  var inputClassName = props.className, label = props.label, href = props.href;
  var hasLabel = [null, void 0].indexOf(label) === -1;
  var hasHref = [null, void 0].indexOf(href) === -1;
  var className = classNames(menuListTitleCls, inputClassName);
  return hasLabel && !hasHref ? /* @__PURE__ */ React.createElement("span", {
    className
  }, label) : /* @__PURE__ */ React.createElement(MenuItemLink, _extends({}, props, {
    bold: true,
    className
  }));
}
__name(MenuListTitle, "MenuListTitle");
export {
  MenuListTitle
};
